import { render } from "./Quill.vue?vue&type=template&id=b6edbfe4"
import script from "./Quill.vue?vue&type=script&lang=js"
export * from "./Quill.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__